<template>
  <div>
    <a-alert
      v-if="errorMessage"
      type="error"
      :message="errorMessage"
      banner
      closable
      @close="errorMessage = null"
    />

    <!-- filter -->
    <ARow :gutter="[8, 8]">
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterToko
          style="width:100%;"
          v-model:value="state.params.toko"
          v-model:vendor_id="state.vendor_id"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-if="!hasRoles([ROLE_DISTRIBUTOR])">
        <FilterDistributor
          style="width:100%;"
          v-model:value="state.params.distributor"
          v-model:vendor_id="state.vendor_id"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12">
        <filter-province
          style="width:100%"
          v-model:value="state.params.provinsi"
          v-can:hide.distributor
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12">
        <filter-area
          style="width:100%"
          v-model:value="state.params.area"
          v-model:area="state.params.area"
          v-model:provinsi="state.params.provinsi"
          v-can:hide.distributor
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12">
        <filter-kabupaten-kota
          style="width:100%"
          v-model:value="state.params.kabupaten"
          v-model:area="state.params.area"
          v-model:provinsi="state.params.provinsi"
          v-can:hide.distributor
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12">
        <filter-opco style="width:100%" v-model:value="state.params.opcos" v-can:hide.distributor />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterATSalesmanDataSample
          style="width:100%;"
          :mode="null"
          v-model:value="state.params.data_sample"
        />
      </ACol>
      <aCol :xl="6" :md="8" :sm="12">
        <FilterATSalesmanSalesman
          style="width:100%;"
          v-model:value="state.params.salesman"
          v-model:useram_id="state.useram_id"
          v-model:vendor_id="state.vendor_id"
        />
      </aCol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-if="!hasRoles([ROLE_TSO])">
        <FilterUsers
          style="width:100%"
          placeholder="Pilih TSO"
          :role_id="55414"
          :mode="null"
          v-model:value="state.params.tso"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-if="!hasRoles([ROLE_ASM])">
        <FilterUsers
          style="width:100%"
          placeholder="Pilih ASM"
          :role_id="55407"
          :mode="null"
          v-model:value="state.params.asm"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterUsers
          style="width:100%"
          placeholder="Pilih SSM"
          :role_id="55403"
          :mode="null"
          v-model:value="state.params.ssm"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <AMonthPicker
          v-model:value="state.params.periode"
          placeholder="Pilih Periode"
          style="width:100%;"
          format="MMMM YYYY"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <AButton type="primary" title="cari" @click="fetchDataList" :loading="state.isFetching">
          <span v-if="!state.isFetching" class="fa fa-search" aria-hidden="true" />
          <span v-else>
            Memuat Data ...
          </span>
        </AButton>
      </ACol>
    </ARow>

    <div class="row justify-content-end mt-4">
      <div class="col-lg-6 col-md-12"></div>
      <div class="col-lg-6 col-md-12 text-right">
        <ASpace>
          <ATooltip title="Download Excel">
            <DownloadExcel :url="state.endpoint" :params="queryParams()" @errors="errorMessage" />
          </ATooltip>
        </ASpace>
      </div>
    </div>

    <!-- list table -->
    <div class="table-responsive text-nowrap mt-4">
      <MdTable
        :columns="state.columns"
        :data-source="state.data"
        size="small"
        :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :pagination="{
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
          showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
          total: state.meta.total,
          pageSize: state.meta.per_page,
          current: state.meta.page,
        }"
        @change="handleTableChange"
        :loading="state.isFetching"
      >
        <template #no="{ index }">
          <span>
            {{ (state.meta.page - 1) * state.meta.per_page + 1 + index }}
          </span>
        </template>
      </MdTable>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, computed } from 'vue'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import FilterToko from '@/components/filter/FilterToko'
import FilterDistributor from '@/components/filter/FilterDistributor'
import FilterProvince from '@/components/filter/FilterProvince'
import FilterArea from '@/components/filter/FilterArea'
import FilterKabupatenKota from '@/components/filter/FilterKabupatenKota'
import FilterOpco from '@/components/filter/FilterOpco'
import FilterATSalesmanDataSample from '@/components/filter/FilterATSalesmanDataSample'
import FilterATSalesmanSalesman from '@/components/filter/FilterATSalesmanSalesman'
import FilterUsers from '@/components/filter/FilterUsers'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import { includes } from 'lodash'
import moment from 'moment'
import localStorage from 'store'
import {
  hasRoles,
  hasPermissions,
  ROLE_TSO,
  ROLE_ADMIN_BK,
  ROLE_TIM_CRM,
  ROLE_CRM_ATSALESMAN,
  ROLE_DISTRIBUTOR,
  ROLE_ASM,
  ROLE_SSM,
  ROLE_GM,
} from '@/helpers'
import { updateUrlWithQuery, extractQueryParams } from '@/helpers/queryparams'

export default defineComponent({
  components: {
    FilterToko,
    FilterDistributor,
    DownloadExcel,
    FilterProvince,
    FilterArea,
    FilterKabupatenKota,
    FilterOpco,
    FilterATSalesmanDataSample,
    FilterATSalesmanSalesman,
    FilterUsers,
  },
  setup() {
    const errorMessage = ref()
    const user = computed(() => localStorage.get('profile'))
    const state = reactive({
      columns: [
        {
          title: 'NO',
          slots: { customRender: 'no' },
        },
        {
          title: 'Kode Toko',
          dataIndex: 'kode_toko',
        },
        {
          title: 'Nama Toko',
          dataIndex: 'nama_toko',
        },
        // {
        //     title: 'Kode Distributor',
        //     dataIndex: 'distributorCode',
        // },
        // {
        //     title: 'Nama Distributor',
        //     dataIndex: 'distributorName',
        // },
        {
          title: 'Provinsi',
          dataIndex: 'provinsi_toko',
        },
        {
          title: 'Area',
          dataIndex: 'area_toko',
        },
        {
          title: 'Kabupaten / Kota',
          dataIndex: 'kota_toko',
        },
        {
          title: 'Area AP',
          dataIndex: 'area_ap',
        },
        {
          title: 'Data Sample',
          dataIndex: 'data_sample',
        },
        {
          title: 'Kode Distributor',
          dataIndex: 'kode_distributor',
        },
        {
          title: 'Nama Distributor',
          dataIndex: 'nama_distributor',
        },
        {
          title: 'ID Salesman',
          dataIndex: 'id_salesman',
        },
        {
          title: 'Nama Salesman',
          dataIndex: 'nama_salesman',
        },
        {
          title: 'SSM',
          dataIndex: 'user_ssm',
        },
        {
          title: 'ASM',
          dataIndex: 'user_asm',
        },
        {
          title: 'TSO',
          dataIndex: 'user_tso',
        },
      ],
      endpoint: '/api/report-ats/reports-unvisited-customers',
      data: [],
      meta: {
        per_page: 10,
        page: 1,
        total: 0,
      },
      isFetching: false,
      params: extractQueryParams({
        q: '',
        salesman: [],
        toko: [],
        distributor: [],
        provinsi: [],
        area: [],
        kabupaten: [],
        opcos: [],
        data_sample: null,
        salesman: [],
        asm: [],
        ssm: [],
        tso: [],
        periode: moment(new Date())
          .startOf('month')
          .format('YYYY-MM'),
        page: 1,
        'per-page': 10,
      }),
      useram_id: null,
      vendor_id: null,
    })

    const handleTableChange = (page, filters, sorter) => {
      state.params.page = page.current
      state.params['per-page'] = page.pageSize

      fetchDataList()
    }

    const queryParams = () => {
      let params = state.params

      if (state.params.periode) {
        params.periode = moment(state.params.periode).format('YYYY-MM')
      }

      return updateUrlWithQuery(params)
    }

    // fetch list data
    const fetchDataList = () => {
      state.isFetching = true

      apiClient
        .get(state.endpoint, {
          params: queryParams(),
        })
        .then(({ data }) => {
          const { items, _meta } = data

          state.data = items
          state.meta.page = _meta.currentPage
          state.meta.per_page = _meta.perPage
          state.meta.total = _meta.totalCount
        })
        .finally(() => {
          state.isFetching = false
        })
    }

    // handle vue
    onMounted(() => {
      if (hasRoles([ROLE_TSO])) {
        state.useram_id = user.value.id
      }

      if (hasRoles([ROLE_DISTRIBUTOR])) {
        state.vendor_id = user.value.vendor_id
      }

      fetchDataList()
    })

    return {
      fetchDataList,
      state,
      queryParams,
      handleTableChange,
      errorMessage,
      // only variable roles
      hasRoles,
      hasPermissions,
      ROLE_TSO,
      ROLE_ADMIN_BK,
      ROLE_TIM_CRM,
      ROLE_CRM_ATSALESMAN,
      ROLE_DISTRIBUTOR,
      ROLE_ASM,
      ROLE_SSM,
      ROLE_GM,
    }
  },
})
</script>
